import { defineStore } from 'pinia';

export const useConfirmStore = defineStore('confirmStore', {
    state: () => ({
        open: false,
        title: '',
        text: '',
        cancelBtnText: 'common.cancel',
        confirmBtnText: 'common.confirm',
        resolve: null as ((result: boolean) => void) | null,
    }),
});
